import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { AvailableProductsList } from '.';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { setRxdb } from '@helper/utils';

export const useAvailableOtherProductsListQuery = (): IQueryResponse<AvailableProductsList[]> => {
	const { shouldFetch, isDbChecked } = useCheckRxdb('other_products');

	const availableOtherProductsList = async (): Promise<AvailableProductsList[]> => {
		const url = `${APICONFIG.AVAILABLE_OTHER_PRODUCTS_LIST}`;
		const response = await APIService.getData<AvailableProductsList[]>(url, {
			limit: '0',
		});
		if (response) {
			response.push({
				id: 0,
				prdgroup3_c: 'NA',
				productgroup3description_c: 'NA',
				averagerateeach_c: 'NA',
				materialdescription_c: null,
				sellingprice_c: 0,
				maximumretailprice_c: 0.0,
				name: 'NA',
			});
			await setRxdb('other_products', response);
		}

		return response;
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['availableOtherProductsList'],
		queryFn: availableOtherProductsList,
		enabled: isDbChecked && shouldFetch,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
